<template>
  <modal ref="modal" static-backdrop width="560px">
    <div class="modal-body">
        <p class="fw-bold h2">Acceptable Use Policy</p>
        <p>You agree not to misuse the AI Avatar Service in any way that infringes upon the rights of others or that is obscene, defamatory, immoral, insulting, threatening, fraudulent, bullying, discriminatory, or harmful. You further agree to comply with the following restrictions:</p>
        <ul>
            <li><span class="fw-bold">Child Safety</span>: Do not threaten, compromise, or otherwise endanger child safety.</li>
            <li><span class="fw-bold">Illegal Behavior</span>: Do not engage in any illegal activities.</li>
            <li><span class="fw-bold">Controlled Goods and Medical Advice</span>: Do not market or sell regulated drugs, controlled goods, or services, or provide medical advice without our prior approval.</li>
            <li><span class="fw-bold">Fraud and Abuse</span>: Do not engage in fraudulent, predatory, abusive, or deceptive practices.</li>
            <li><span class="fw-bold">Impersonation</span>: Do not engage in unauthorized or harmful impersonation, including representing an avatar as a real person providing services or selling products.</li>
            <li><span class="fw-bold">Unauthorized Access and Surveillance</span>: Do not engage in unauthorized access to networks, systems, or engage in surveillance activities.</li>
            <li><span class="fw-bold">Violent, Hateful, or Harassing Content</span>: Do not create content that is violent, hateful, or harassing.</li>
            <li><span class="fw-bold">Prohibited and High-Risk Uses</span>: Do not use the Services or their outputs in any manner classified as "prohibited" or "high-risk" under applicable law, including Applicable AI Laws such as the European Union's Artificial Intelligence Act, Regulation (EU) 2024/1689.</li>
        </ul>
        <p class="mb-0">AI Avatar Service may, but is not obligated to, monitor Your Content for compliance with this Acceptable Use Policy. If your content is automatically flagged for a potential policy violation, it may undergo manual review or be automatically rejected. In cases of flagrant or repeated violations of this Acceptable Use Policy, we reserve the right to immediately discontinue your access to the Service.</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" @click="confirm">Continue</button>
    </div>
  </modal>
</template>
<script>
import { loadSettings, saveSettings } from "@/utils/browser";

export default {
    mounted() {
        const agreed = loadSettings("agreed");
        if (!agreed) {
            this.$refs.modal.open();
        }
    },
    methods: {
        confirm() {
            saveSettings("agreed", true);
            this.$refs.modal.close();
        }
    }
};
</script>
